import React, { Component } from "react";
import MetricsLabView from "./MetricsLabView";

export default class MetricsLabContainer extends Component {
  render() {
    const { details } = this.props;

    return <>{details && <MetricsLabView details={details} />}</>;
  }
}
